<section class="py-6 text-center">
  <p class="text-xs font-bolduppercase text-[#838A98] mb-4">
    {{ 'talentSearchV2.trustedBy.title' | translate }}
  </p>

  <div class="logos-marquee">
    <div class="logos-track">
      <div class="logo-item" *ngFor="let logo of companyLogos">
        <img [src]="logo.src" [alt]="logo.alt" loading="lazy">
      </div>
      <!-- Duplicate for seamless loop -->
      <div class="logo-item" *ngFor="let logo of companyLogos">
        <img [src]="logo.src" [alt]="logo.alt" loading="lazy">
      </div>
    </div>
  </div>
</section>
